export const HOME_GET_SYSTEM_COUNT_BEGIN = 'HOME_GET_SYSTEM_COUNT_BEGIN';
export const HOME_GET_SYSTEM_COUNT_SUCCESS = 'HOME_GET_SYSTEM_COUNT_SUCCESS';
export const HOME_GET_SYSTEM_COUNT_FAILURE = 'HOME_GET_SYSTEM_COUNT_FAILURE';
export const HOME_GET_SYSTEM_COUNT_DISMISS_ERROR = 'HOME_GET_SYSTEM_COUNT_DISMISS_ERROR';
export const HOME_GET_HOT_BY_POSITION_TYPE_BEGIN = 'HOME_GET_HOT_BY_POSITION_TYPE_BEGIN';
export const HOME_GET_HOT_BY_POSITION_TYPE_SUCCESS = 'HOME_GET_HOT_BY_POSITION_TYPE_SUCCESS';
export const HOME_GET_HOT_BY_POSITION_TYPE_FAILURE = 'HOME_GET_HOT_BY_POSITION_TYPE_FAILURE';
export const HOME_GET_HOT_BY_POSITION_TYPE_DISMISS_ERROR = 'HOME_GET_HOT_BY_POSITION_TYPE_DISMISS_ERROR';
export const HOME_GET_HOT_BY_AREA_BEGIN = 'HOME_GET_HOT_BY_AREA_BEGIN';
export const HOME_GET_HOT_BY_AREA_SUCCESS = 'HOME_GET_HOT_BY_AREA_SUCCESS';
export const HOME_GET_HOT_BY_AREA_FAILURE = 'HOME_GET_HOT_BY_AREA_FAILURE';
export const HOME_GET_HOT_BY_AREA_DISMISS_ERROR = 'HOME_GET_HOT_BY_AREA_DISMISS_ERROR';
export const HOME_GET_COUNT_BY_POSITION_TYPE_BEGIN = 'HOME_GET_COUNT_BY_POSITION_TYPE_BEGIN';
export const HOME_GET_COUNT_BY_POSITION_TYPE_SUCCESS = 'HOME_GET_COUNT_BY_POSITION_TYPE_SUCCESS';
export const HOME_GET_COUNT_BY_POSITION_TYPE_FAILURE = 'HOME_GET_COUNT_BY_POSITION_TYPE_FAILURE';
export const HOME_GET_COUNT_BY_POSITION_TYPE_DISMISS_ERROR = 'HOME_GET_COUNT_BY_POSITION_TYPE_DISMISS_ERROR';
export const HOME_COUNT_BY_EDU_BEGIN = 'HOME_COUNT_BY_EDU_BEGIN';
export const HOME_COUNT_BY_EDU_SUCCESS = 'HOME_COUNT_BY_EDU_SUCCESS';
export const HOME_COUNT_BY_EDU_FAILURE = 'HOME_COUNT_BY_EDU_FAILURE';
export const HOME_COUNT_BY_EDU_DISMISS_ERROR = 'HOME_COUNT_BY_EDU_DISMISS_ERROR';
export const HOME_COUNT_BY_AGE_BEGIN = 'HOME_COUNT_BY_AGE_BEGIN';
export const HOME_COUNT_BY_AGE_SUCCESS = 'HOME_COUNT_BY_AGE_SUCCESS';
export const HOME_COUNT_BY_AGE_FAILURE = 'HOME_COUNT_BY_AGE_FAILURE';
export const HOME_COUNT_BY_AGE_DISMISS_ERROR = 'HOME_COUNT_BY_AGE_DISMISS_ERROR';
export const HOME_COUNT_BY_GENDER_BEGIN = 'HOME_COUNT_BY_GENDER_BEGIN';
export const HOME_COUNT_BY_GENDER_SUCCESS = 'HOME_COUNT_BY_GENDER_SUCCESS';
export const HOME_COUNT_BY_GENDER_FAILURE = 'HOME_COUNT_BY_GENDER_FAILURE';
export const HOME_COUNT_BY_GENDER_DISMISS_ERROR = 'HOME_COUNT_BY_GENDER_DISMISS_ERROR';
export const HOME_GET_SEND_POSITION_ACTION_BEGIN = 'HOME_GET_SEND_POSITION_ACTION_BEGIN';
export const HOME_GET_SEND_POSITION_ACTION_SUCCESS = 'HOME_GET_SEND_POSITION_ACTION_SUCCESS';
export const HOME_GET_SEND_POSITION_ACTION_FAILURE = 'HOME_GET_SEND_POSITION_ACTION_FAILURE';
export const HOME_GET_SEND_POSITION_ACTION_DISMISS_ERROR = 'HOME_GET_SEND_POSITION_ACTION_DISMISS_ERROR';
export const HOME_GET_BROWER_ACTION_BEGIN = 'HOME_GET_BROWER_ACTION_BEGIN';
export const HOME_GET_BROWER_ACTION_SUCCESS = 'HOME_GET_BROWER_ACTION_SUCCESS';
export const HOME_GET_BROWER_ACTION_FAILURE = 'HOME_GET_BROWER_ACTION_FAILURE';
export const HOME_GET_BROWER_ACTION_DISMISS_ERROR = 'HOME_GET_BROWER_ACTION_DISMISS_ERROR';
export const HOME_GET_POSITION_BROWER_ACTION_BEGIN = 'HOME_GET_POSITION_BROWER_ACTION_BEGIN';
export const HOME_GET_POSITION_BROWER_ACTION_SUCCESS = 'HOME_GET_POSITION_BROWER_ACTION_SUCCESS';
export const HOME_GET_POSITION_BROWER_ACTION_FAILURE = 'HOME_GET_POSITION_BROWER_ACTION_FAILURE';
export const HOME_GET_POSITION_BROWER_ACTION_DISMISS_ERROR = 'HOME_GET_POSITION_BROWER_ACTION_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/home/redux/constants.js